// extracted by mini-css-extract-plugin
module.exports = {"footerNav":"terms_footerNav_3yCRq"};